export const CONTACT = {
  phone: "(53) 99955-0585",
  wa: "5553999550585",
  email: "meloagroengenharia@gmail.com",
  address: "Rua Santos Dumont, 324 — Centro",
  city: "Pelotas/RS",
  cep: "CEP 96020-380",
  hours: "Segunda a sexta, das 8h às 12h e das 14h às 18h",
  instagram: "https://www.instagram.com/meloagroengenharia",
  instagramHandle: "@meloagroengenharia",
  region: "Metade Sul do RS",
};

export const waLink = (text = "Olá! Gostaria de falar com a Melo Agro Engenharia.") =>
  `https://wa.me/${CONTACT.wa}?text=${encodeURIComponent(text)}`;

export const MAPS_LINK =
  "https://www.google.com/maps/search/?api=1&query=" +
  encodeURIComponent("Rua Santos Dumont 324, Centro, Pelotas RS, 96020-380");

export const LINKEDIN = "https://www.linkedin.com/in/lucas-melo-3993b1313";

export const FOOTER_LINE = "Melo Agro Engenharia Ltda. · CNPJ 40.832.207/0001-47 · CREA PJ 253.838 · desde 2021";

// Aviso sazonal configurável — ativar (enabled: true) e definir datas AAAA-MM-DD.
// Exemplos: "Plano Safra aberto: garanta seu custeio" · "Prazo do ITR: regularize agora"
export const SEASONAL = {
  enabled: false, // ative (true) e defina as datas AAAA-MM-DD quando houver campanha
  // Exemplos: "Plano Safra aberto: garanta seu custeio" · "Prazo do ITR: regularize agora"
  text: "Plano Safra aberto: garanta seu custeio",
  start: "",
  end: "",
};

export const NAV = [
  { id: "sobre", label: "Sobre" },
  { id: "servicos", label: "Serviços" },
  { id: "metodo", label: "Como trabalhamos" },
  { id: "atuacao", label: "Atuação" },
  { id: "contato", label: "Contato" },
];

export const TAGLINE = "Assistência técnica, engenharia e crédito rural para a metade sul do Rio Grande do Sul";

export const CREDS = [
  { label: "Responsável técnico", value: "Lucas Melo — CREA-RS 244.373" },
  { label: "Empresa", value: "Melo Agro Engenharia Ltda. — CREA PJ 253.838" },
  { label: "CNPJ", value: "40.832.207/0001-47" },
];

// Dimensões reais das fotos (width/height sem CLS) — variantes responsivas geradas em /img/*-480w|-960w|-1440w.
export const IMG_DIMS = {
  "/img/tractor.webp": [1400, 1049],
  "/img/contour.webp": [1400, 1050],
  "/img/farm-aerial.webp": [1600, 1200],
  "/img/inspect.webp": [1200, 1842],
  "/img/pampa.webp": [1800, 1200],
  "/img/furrows.webp": [1400, 788],
  "/img/corn.webp": [1200, 1600],
  "/img/rice.webp": [1600, 1067],
  "/img/soja-fileiras.webp": [960, 1280],
  "/img/soja-vistoria.webp": [960, 1280],
  "/img/soja-sunset.webp": [960, 1280],
  "/img/engenheiro-lucas-soja.webp": [960, 1280],
  "/img/pastagem-gado.webp": [961, 1280],
  "/img/pastagem-recria.webp": [736, 1200],
  "/fotos/lucas-campo.webp": [960, 1280],
};

// Descrições da cena real de cada foto — alt padronizado em todos os usos da imagem.
export const IMG_ALTS = {
  "/img/tractor.webp": "Trator preparando o solo ao pôr do sol em grandes talhões",
  "/img/contour.webp": "Vista aérea de trator arando solo vermelho junto a campos com curvas de nível",
  "/img/farm-aerial.webp": "Vista aérea de colheitadeira e trator com carroça colhendo milho em grande talhão",
  "/img/inspect.webp": "Profissional com prancheta avaliando lavoura de trigo dourado",
  "/img/pampa.webp": "Gado de corte em coxilhas verdes com morros ao fundo na Metade Sul do RS",
  "/img/furrows.webp": "Vista aérea de máquina trabalhando entre faixas de manejo em lavoura",
  "/img/corn.webp": "Produtor com chapéu de palha caminhando em lavoura de milho",
  "/img/rice.webp": "Arrozais irrigados ao pôr do sol",
  "/img/soja-fileiras.webp": "Fileiras de lavoura de soja em campo da Metade Sul do RS",
  "/img/soja-vistoria.webp": "Picape em vistoria de lavoura de soja com lagoa ao fundo na Metade Sul do RS",
  "/img/soja-sunset.webp": "Lavoura de soja ao pôr do sol na Metade Sul do RS",
  "/img/engenheiro-lucas-soja.webp": "Engenheiro Lucas Melo em vistoria de lavoura de soja na Metade Sul do RS",
  "/img/pastagem-gado.webp": "Gado de corte em pastagem da Metade Sul do Rio Grande do Sul",
  "/img/pastagem-recria.webp": "Pastagem de inverno com azevém e trevo usada em projeto de recria bovina",
  "/fotos/lucas-campo.webp": "Engenheiro Lucas Melo em vistoria de lavoura de soja na Metade Sul do RS",
};

// srcSet com as variantes geradas + original (largura real); undefined quando não há variantes.
export const srcSetFor = (src) => {
  const dims = IMG_DIMS[src];
  if (!dims) return undefined;
  const base = src.replace(/\.[a-z]+$/i, "");
  const parts = [];
  for (const w of [480, 960, 1440]) if (w < dims[0]) parts.push(`${base}-${w}w.webp ${w}w`);
  parts.push(`${src} ${dims[0]}w`);
  return parts.join(", ");
};

export const SERVICES = [
  {
    id: "credito-rural",
    n: "01",
    title: "Projetos de Crédito Rural",
    text: "Custeio e investimento, com Pronaf, Pronamp, RenovAgro e demais linhas do Plano Safra — projeto técnico, orçamento e documentação.",
    tag: "Custeio · Investimento",
    span: "md:col-span-7",
    img: "/img/soja-fileiras.webp",
    alt: "Fileiras de lavoura de soja em campo da Metade Sul do RS",
  },
  {
    id: "avaliacoes",
    n: "02",
    title: "Avaliações",
    text: "Imóveis rurais e urbanos e máquinas e equipamentos agrícolas, para garantia de crédito, negociação, partilha e inventário (ABNT NBR 14653).",
    tag: "Imóveis · Máquinas",
    span: "md:col-span-5",
    img: "/img/contour.webp",
    alt: "Vista aérea de trator arando solo vermelho junto a campos com curvas de nível",
  },
  {
    id: "laudos-tecnicos",
    n: "03",
    title: "Laudos Técnicos Agronômicos",
    text: "Laudos claros e fundamentados para bancos, seguradoras, cartórios e órgãos públicos.",
    tag: "Documentação técnica",
    span: "md:col-span-4",
    img: "/img/inspect.webp",
    alt: "Profissional com prancheta avaliando lavoura de trigo dourado",
  },
  {
    id: "pericias-judiciais",
    n: "04",
    title: "Perícias Agrícolas e Judiciais",
    text: "Atuação como perito judicial em ações que envolvem imóveis rurais e urbanos, lavouras, pecuária, crédito rural e seguro agrícola, com laudos fundamentados na NBR 14653.",
    tag: "Judicial · Extrajudicial",
    span: "md:col-span-4",
    dark: true,
  },
  {
    id: "regularizacao-rural",
    n: "05",
    title: "Regularização Rural",
    text: "CAR, CCIR, ITR e matrícula atualizada — análise de cadeia dominial e atualização cadastral do imóvel.",
    tag: "Documentação da terra",
    span: "md:col-span-4",
  },
  {
    id: "assessoria",
    n: "06",
    title: "Assessoria Especializada",
    text: "Assessoria bancária e jurídica: contratos de arrendamento, comodato e parceria agrícola.",
    tag: "Bancária · Jurídica",
    span: "md:col-span-4",
  },
  {
    id: "reestruturacao-de-dividas-rurais",
    n: "07",
    title: "Reestruturação de Crédito Rural",
    text: "Renegociação e prorrogação de dívidas rurais junto aos agentes financeiros.",
    tag: "Renegociação",
    span: "md:col-span-4",
    ochre: true,
  },
  {
    id: "seguro-agricola",
    n: "08",
    title: "Seguros Agrícolas",
    text: "Orientação na contratação, Proagro, vistoria e perícia de sinistro para proteger a lavoura.",
    tag: "Proteção da safra",
    span: "md:col-span-4",
  },
];

export const SERVICE_ICONS = {
  "credito-rural": "coins",
  "avaliacoes": "ruler",
  "laudos-tecnicos": "file",
  "pericias-judiciais": "scale",
  "regularizacao-rural": "filecheck",
  "assessoria": "handshake",
  "reestruturacao-de-dividas-rurais": "refresh",
  "seguro-agricola": "umbrella",
};

export const MUNICIPIOS = [
  "Pedras Altas", "Herval", "Arroio Grande", "Jaguarão", "Hulha Negra", "Bagé",
  "Dom Pedrito", "Piratini", "Canguçu", "Pelotas", "Capão do Leão", "Rio Grande",
  "São Lourenço do Sul", "Cristal", "Camaquã", "Chuvisca", "Dom Feliciano",
  "Turuçu", "Pinheiro Machado", "Candiota", "Pedro Osório", "Cerrito",
];

export const CADEIAS = ["Soja", "Milho (grão e silagem)", "Arroz irrigado", "Pecuária de corte", "Pecuária de leite"];

export const MARQUEE = [
  "Projetos de Crédito Rural",
  "Avaliações",
  "Laudos Técnicos Agronômicos",
  "Perícias Agrícolas e Judiciais",
  "Regularização Rural",
  "Assessoria Especializada",
  "Reestruturação de Crédito Rural",
  "Seguros Agrícolas",
];
